import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginResponse } from '../security/login-response';
import { HttpClient, HttpHandler, HttpHeaders } from '@angular/common/http';
import { LoginService } from '../security/login.service';
import { environment } from 'src/environments/environment';
import { UserService } from '../service/user.service';
import { NavigationService } from '../service/navigation.service';
import { HttpService } from '../service/http.service';

@Component({
  selector: 'app-redirecting',
  templateUrl: './redirecting.component.html',
  styleUrl: './redirecting.component.css'
})
export class RedirectingComponent {

  constructor(
    private router: Router,
    private loginService: LoginService,
    private http: HttpClient,
    private userService: UserService,
    private navigationService: NavigationService,
    private httpService: HttpService
  ) {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    this.loginService.activatedNavigationComponent = false;
    this.loginService.isLoginComponent = true;

    if (code) {
      const backendUrl = environment.sbmsUrl;

      this.httpService.getCsrfToken().subscribe(() => {
        this.http.post<LoginResponse>(backendUrl + "/authorization/" + code, null, { withCredentials: true }).subscribe(res => {
          localStorage.setItem("isConnected", "true");
          console.log("redirecting component");
          this.userService.updateUserInfo().subscribe(() => {
            this.navigationService.setItems();
            this.router.navigate([res.redirectTo]);
          });
        }, error => {
          console.error(error);
        });
      }, error => {
        console.error(error);
      });

    }
  }

  getCookieValue(cookieName: string, cookieStr: string): string | null {
    const cookies = cookieStr.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === cookieName) {
        return value;
      }
    }
    return null;
  }

}
